import React, { useState, useEffect } from "react";
import Layout from "@components/layouts/Layout";
import Seo from "@components/common/Seo";
import SmallBanner from "@components/common/SmallBanner";
import Title from "@components/common/Title";
import Text from "@components/common/Text";
import Products from "@components/sections/Products";
import ProductsNew from "@components/sections/products2/Products";
import dayjs from "dayjs";
import axios from "axios";
import useSWR from "swr";

const endpoints = {
    products: "/.netlify/functions/products",
};

const fetcher = ([url, body]) => axios.post(url, body).then(res => res);

const Tienda = () => {
    // Obtenemos los productos de la tienda
    // y los filtramos por los que están habilitados.
    // Evitamos que se dupliquen las peticiones en 15 segundos.
    const categories = ["sports"];

    const {
        data: result,
        // error,
        isLoading,
        isValidating,
    } = useSWR(categories ? [endpoints.products, { filters: categories }] : null, fetcher, {
        dedupingInterval: 30000, // evita peticiones duplicadas durante 30s
    });

    const [productsState, setProductsState] = useState([]);

    useEffect(() => {
        if (result?.data?.products) {
            let products = result?.data?.products.filter(
                x => x.enabled && !x.hidden && x.category?.includes("sports"),
            );

            products = products.map(p => {
                const { created_at, updated_at, ...rest } = p;
                return {
                    ...rest,
                    created_at: dayjs(created_at).toDate(),
                    updated_at: dayjs(updated_at).toDate(),
                };
            });

            products = products.sort((a, b) => b.stock - a.stock || b.created_at - a.created_at);

            setProductsState(products);
        }
    }, [result]);

    return (
        <>
            <Layout>
                <Seo
                    title="Nuestra tienda: Pruebas físicas"
                    description="Nuestros entrenadores conseguirán que alcances la fuerza
                        estática máxima, la mayor potencia aeróbica y la
                        agilidad para convertirte en el más rápido."
                />
                <SmallBanner
                    title="Pruebas físicas"
                    alt="Pruebas físicas"
                    subtitle="Gana fuerza, potencia y agilidad."
                    filename="bgs/bgSports"
                />

                <div className="container lg:px-0 py-20">
                    <Title>Pruebas disponibles</Title>
                    <Text className="text-justify">
                        Nuestros entrenadores conseguirán que alcances la fuerza estática máxima, la
                        mayor potencia aeróbica y la agilidad para convertirte en el más rápido.
                    </Text>

                    <div className="mt-10 space-y-10">
                        {process.env.GATSBY_NEW_PRODUCTS_ENABLED === "true" ? (
                            <ProductsNew
                                items={productsState}
                                loading={isLoading || isValidating}
                            />
                        ) : (
                            <Products items={productsState} />
                        )}

                        <div className="mt-10 text-right text-xs italic font-montserrat text-gray-500">
                            * I.V.A. incluido en todos los precios
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    );
};

export default Tienda;
